









































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { TransStatement } from '@/common/api/model';
import { TransactionType } from '@/common/config';
import { formatMoney } from '@/common/utils';
import { TRANSACTION_PREPOSITION_ENUM, TRANSACTION_STATUS_ENUM, TRANSACTION_STATUS_NAME_ENUM } from '@/common/transaction-utils';

import MdRadioButtonChecked from '@/components/icons/MdRadioButtonChecked.vue';
import MdRadioButtonUnchecked from '@/components/icons/MdRadioButtonUnchecked.vue';

import FaCheckSquare from '@/components/icons/FaCheckSquare.vue';
import FaRegSquare from '@/components/icons/FaRegSquare.vue';

import ThemeButton from '@/components/ThemeButton.vue';

const userModule = namespace('user');

@Component({
  components: {
    ThemeButton,
    MdRadioButtonChecked,
    MdRadioButtonUnchecked,
    FaCheckSquare,
    FaRegSquare,
  },
  filters: {
    formatDate (value: any) {
      const options = { hour12: false, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' } as const;
      const date = new Date(value);
      return date.toLocaleString(undefined, options);
    },
    formatDay (value: any) {
      const options = { hour12: false, year: 'numeric', month: 'numeric', day: 'numeric' } as const;
      const date = new Date(value);
      return date.toLocaleString(undefined, options);
    },
    formatTime (value: any) {
      const options = { hour12: false, hour: 'numeric', minute: 'numeric', second: 'numeric' } as const;
      const date = new Date(value);
      return date.toLocaleString(undefined, options);
    },
    formatMoney (value: number) {
      return formatMoney(value);
    },
  },
})
export default class TransactionItems extends Vue {
  @Prop({ default: () => ([]) }) readonly transactions!: TransStatement[];
  @Prop({ default: '' }) readonly transactionType!: TransactionType;
  @Prop(Boolean) readonly viewOnly!: boolean;

  @userModule.Getter('currency') currency!: string;
  selectedTransaction: TransStatement[] = [];

  readonly TRANSACTION_PREPOSITION_ENUM = TRANSACTION_PREPOSITION_ENUM;
  readonly TRANSACTION_STATUS_ENUM = TRANSACTION_STATUS_ENUM;
  readonly TRANSACTION_STATUS_NAME_ENUM = TRANSACTION_STATUS_NAME_ENUM;

  expandedTrans: string[] = [];
  submitted = false;

  get actionType () {
    return TransactionType[this.transactionType];
  }
  get preposition () {
    return this.TRANSACTION_PREPOSITION_ENUM[this.transactionType];
  }
  get isNoRecord () {
    return this.transactions.length === 0;
  }
  get operator () {
    return this.transactionType === TransactionType.Deposit ? '+' : '-';
  }
  get isDepositList () {
    return this.transactionType === TransactionType.Deposit;
  }

  get transactionsToShow () {
    return this.transactions;
  }

  toggleTransactionSelection (transaction: TransStatement) {
    if (this.submitted) return;
    if (this.selectedTransaction.includes(transaction)) {
      this.selectedTransaction = this.selectedTransaction.filter(t => t !== transaction);
    } else {
      this.selectedTransaction = [...this.selectedTransaction, transaction];
    }
  }

  expandTrans (tradeId: string) {
    const index = this.expandedTrans.indexOf(tradeId);
    const exist = index !== -1;
    if (exist) {
      this.expandedTrans.splice(index, 1);
    } else {
      this.expandedTrans.push(tradeId);
    }
  }

  isTransactionSelected (transaction: TransStatement) {
    return this.selectedTransaction.includes(transaction);
  }

  proceed () {
    if (this.viewOnly) return;
    const selectedList = this.selectedTransaction;
    if (!selectedList?.length || this.submitted) return;

    const issueMessages = selectedList.reduce((acc: string[], cur) => {
      const authority = cur.counterAuthority ? cur.counterAuthority : cur.counterFull;
      const msg = `${this.actionType} ${authority ? this.preposition : ''} ${authority || ''} ${formatMoney(cur.amount)} ${this.currency} (transaction id: ${cur.tradeId})`;
      return [...acc, msg];
    }, []);

    this.$emit('input', { type: this.transactionType, issueMessages, selected: selectedList });
    this.submitted = true;
  }
}
